import { forwardRef } from 'react';
import { Panel, type PanelProps } from '@frekuent/orbit/components';
import { cn } from '@frekuent/orbit/utils';

/**
 * Orbit's `Panel` is a block `div`. The legacy `.container` class it replaced was a full-width
 * flex column, so every migrated call site had to re-declare the same four classes. This owns
 * them instead.
 *
 * `className` still lands last inside `cn`, so a call site overrides any of them the usual way:
 * `justify-start`, `items-center`, a narrower `max-w-*`.
 */
const FlexPanel = forwardRef<HTMLDivElement, PanelProps>(({ className, ...rest }, ref) => (
	<Panel
		ref={ref}
		className={cn('flex w-full flex-col justify-center', className)}
		{...rest}
	/>
));

FlexPanel.displayName = 'FlexPanel';

export default FlexPanel;
